import {Component, Input} from "@angular/core";
import {BaseComponent} from "../../../base.component";
import {LoggerService} from "../../../common/logger.service";
import {UserService} from "../../../common/user.service";
import {GqlShopSessionService} from "../../../../checkout/graphql/shop-session/gql-shop-session.service";
import {ShopSessionUtil} from "../shop-session-util";

@Component({
    selector: 'ssd-totals-table',
    templateUrl: './ssd-totals-table.component.html',
    styleUrls: ['../shop-session-dashboard-tab.scss'],
    standalone: false
})
export class SsdTotalsTableComponent extends BaseComponent {

    @Input() countryTotals: any = [];
    @Input() shopperSource: string = "all";
    expandedRows: boolean[] = [];

    constructor(
        loggerService: LoggerService,
        userService: UserService,
        private gqlShopSessionService: GqlShopSessionService,
    ) {
        super(userService, loggerService);
    }

    toggleExpand(index: number): void {
        this.expandedRows[index] = !this.expandedRows[index];
    }

    getBarStyle(value: number, property: string): any {
        return ShopSessionUtil.getBarStyle( this.countryTotals, value, property);
    }
}
